import moment from 'moment';
import Bignumber from 'bignumber.js';
import { history } from '@ice/runtime';
import Requests from '@/services/request';
import { getQueryStringArgs, queryStringify } from '@/utils/url-parse';

/**
 * 时间格式化
 * @param time 时间戳
 * @returns
 */
export function formatTime(time) {
  // if (typeof time !== 'number' || isNaN(time)) return '';
  if (!time) return '';
  try {
    const _time = moment(time).format('YYYY-MM-DD HH:mm:ss');
    return _time;
  } catch (err) {
    return '';
  }
}

/**
 * 结构体处理多余属性
 * @param props
 * @param excludeProps 需要过滤的属性
 * @returns
 */
export function propsFilter(props: any, excludeProps: string[] = []) {
  const newProps = { ...props };
  excludeProps.forEach((ex) => {
    delete newProps[ex];
  });
  return newProps;
}

/**
 * 文件大小换算
 * @param size
 * @returns
 */
export function getFileSize(size) {
  // 把字节转换成正常文件大小
  if (!size) return '';
  const num = 1024; // byte
  if (size < num) return `${size}B`;
  if (size < Math.pow(num, 2)) return `${new Bignumber(size).div(num).toFixed(2)}KB`; // kb
  if (size < Math.pow(num, 3)) return `${new Bignumber(size).div(Math.pow(num, 2)).toFixed(2)}MB`; // M
  if (size < Math.pow(num, 4)) return `${new Bignumber(size).div(Math.pow(num, 3)).toFixed(2)}G`; // G
  return `${new Bignumber(size).div(Math.pow(num, 4)).toFixed(2)}T`; // T
}

/**
 * 根据字符串内容生成hash值
 */
export function getStringHash(str?: string) {
  if (!str) {
    return 0;
  }
  let hash = 0;
  let chr;
  for (let i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

/**
 * 生成种子随机数
 * @param seed 随机种子
 * @param max 范围最大值
 * @param min 范围最小值
 */
export function seededRandom(seed: number, max?: number, min?: number) {
  const _max = max || 1;
  const _min = min || 0;

  const _seed = (seed * 9301 + 49297) % 233280;
  const rnd = _seed / 233280.0;

  return Math.ceil(_min + rnd * (_max - _min));
}

/**
 * 解析cookie
 */

export function getCookie(key: string) {
  let res: string = '';
  if (key) {
    const cookieArr = document.cookie.replace(/\s+/g, '').split(';');
    cookieArr.forEach((item) => {
      const s = item.split('=');
      if (s[0] === key) {
        res = s[1];
      }
    });
  }
  let result: string;
  try {
    result = decodeURIComponent(res);
  } catch (error) {
    result = res;
  }
  return result;
}

export const isSameMicroApp = (path) => {
  path = path.split('/')[1];
  const currentPath = window.location.hash.replace('#', '')?.split('/')[1]
  return currentPath === path;
}

export const goToDuiba = (spaceId) => {
  const { origin, pathname, hash } = window.location;
  window.location.href = `${origin}${pathname}?${queryStringify({ spaceId: spaceId || '' })}${
    hash.indexOf('#/duiba') !== -1 ? hash : '#/duiba'
  }`;
};

export const goToLingyang = (spaceId, path) => {
  const { origin, pathname } = window.location;
  window.location.href = `${origin}/superapp?${queryStringify({ spaceId: spaceId || '' })}#${path}`;
}

export const handleRedirect = (spaceId, isDuibaUser, spaceRoleDispatcher) => {
  const { redirect = '', spaceId: urlSpaceId } = getQueryStringArgs();
  const initSpaceId = urlSpaceId || spaceId;
  Requests.get('/rest/intercnn/space/query', {
    status: 'ACTIVE',
    pageSize: 1000,
  }).then((data) => {
    let _spaceId = '';
    const { list = [] } = data;
    const newList =
      list?.map((item) => {
        return {
          ...item,
          roleList: item?.role?.split(',') || [],
        };
      }) || [];
    const urlSpace = newList.find((i) => i.spaceId === initSpaceId);
    const space = urlSpace || newList?.[0] || {};

    _spaceId = space.spaceId || '';
    spaceRoleDispatcher.updateCharacterInfo(space);

    if (redirect) {
      // 校验跳转页面是否在白名单内
      if ([location.hostname].includes(new URL(redirect).hostname)) {
        window.location.replace(redirect);
        return;
      }
    }

    // 非兑吧 && 用户没有可用空间: 跳转到waiting页面
    if (!isDuibaUser && !newList.length) {
      history?.push('/waiting');
      return;
    }

    history?.push(`/?spaceId=${_spaceId}`);
  });
};

export const goHome = (spaceId) => {
  const { origin, pathname } = window.location;
  window.location.href = `${origin}/superapp?${queryStringify({ spaceId: spaceId || '' })}#/?${queryStringify({ spaceId: spaceId || '' })}`;
}

export const safetyRequest = (callback = () => {}) => {
  if (window.__SUPERAPP_CONFIG__?.enableSecureChecker !== 'baxia') return;
  const script = document.createElement('script');
  script.src = '//g.alicdn.com/??AWSC/AWSC/awsc.js,sd/baxia-entry/baxiaCommon.js';
  script.onload = () => {
    const obj = {
      checkApiPath: (url) => {
        if (
          [
            '/uc/login',
            '/uc/risk/second/verification',
            '/uc/risk/aliyun/report',
            '/rest/intercnn/user/register',
            '/rest/intercnn/user/modify',
          ].includes(url)
        )
          return true;
      },
      ppendTo: 'default',
      paramsType: ['uab', 'umid', 'et', 'Collina'],
    };
    window.baxiaCommon && window.baxiaCommon.init({ ...obj });
    callback();
  };
  document.body.appendChild(script);
};

export function echartsResize(type: string, chartInstance?: any) {
  try {
    const resize = () => {
      setTimeout(() => {
        chartInstance && chartInstance?.resize && chartInstance.resize();
      }, 200);
    };
    if (type !== 'add') {
      // 解绑事件
      window.removeEventListener('resize', resize);
      return;
    }

    // 绑定事件
    if (!chartInstance) {
      // 图表实例
      return;
    }
    window.addEventListener('resize', resize);
  } catch (err) {
    console.error('resize', err);
  }
}

export const getEnv = () => {
  const { content }: any = document.head.querySelector('meta[name="deploy-env"]') || {};
  return content;
};

export const checkPathJurisdiction = (menuList: any, pathName: string, spaceRoleState: any) => {
  let hasPermission = false;
  if (
    pathName === '/platformInfoSettings' &&
    spaceRoleState?.type === 'CONSUMER' &&
    spaceRoleState?.roleList?.includes('ADMIN')
  ) {
    return true;
  }

  const isLingYangRoleAdmin = spaceRoleState?.roleList?.includes('ADMIN'); // 管理员&羚羊
  const isLingYangRole =
    !spaceRoleState?.roleList?.includes('ADMIN') && spaceRoleState?.roleList?.includes('OPERATOR'); // 非管理员&羚羊

  function check(_menuList) {
    for (let i = 0; i < _menuList.length; i++) {
      if (
        _menuList[i].path &&
        (_menuList[i].path === pathName || pathName.startsWith(_menuList[i].path))
      ) {
        hasPermission = true;
        return;
      }
      if (_menuList[i].children?.length) {
        check(_menuList[i].children);
      }
    }
  }

  // 运营角色
  if (
    (isLingYangRole && pathName.startsWith('/ly_analyse')) ||
    (isLingYangRoleAdmin &&
      (pathName.startsWith('/ly_analyse') || pathName.startsWith('/ly_track')))
  ) {
    hasPermission = true;
  } else {
    check(menuList);
  }

  return hasPermission;
};
